<template lang="pug">
  .pin-info-area
    .info-button(@click="openInfo", :class="{ 'info-button-sp': spMode }")
      a.icon
    .info-text(v-if="infoArea", :class="{ 'info-text-sp': spMode }")
      button.close-button(@click="openInfo")
      p.title Map上のピンについて
      p
        | ピンは今月の予算で配色が変わります。
        br
        | 今月の予算が存在しない場合は過去の予算をもとに配色されます。
        br
        | 予算額のデータが存在しない場合は白色のピンになります。
      .budget-table
        table
          tr
            th ピン
            th 今月
            th 先月
            th 直近3ヶ月
            th 直近半年
            th 直近1年
          tr
            td.pin1
            td 20万未満
            td 30万未満
            td 60万未満
            td 100万未満
            td 300万未満
          tr
            td.pin2
            td 20万~39万
            td 30万~59万
            td 60万~99万
            td 100万~599万
            td 300万~799万
          tr
            td.pin3
            td 40万~69万
            td 60万~99万
            td 100万~399万
            td 600万~1099万
            td 800万~1299万
          tr
            td.pin4
            td 70万~99万
            td 100万~399万
            td 400万~699万
            td 1100万~1599万
            td 1300万~1799万
          tr
            td.pin5
            td 100万~299万
            td 400万~699万
            td 700万~999万
            td 1600万~2099万
            td 1800万~2399万
          tr
            td.pin6
            td 300万~599万
            td 700万~999万
            td 1000万~1299万
            td 2100万~2599万
            td 2400万~2999万
          tr
            td.pin7
            td 600万~
            td 1000万~
            td 1300万~
            td 2600万~
            td 3000万~
</template>

<script>
  export default {
    props: ['spMode'],
    data () {
      return {
        infoArea: false,
      }
    },
    methods: {
      openInfo () {
        this.infoArea = !this.infoArea
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/MapPinInfo.vue